import axios from 'axios';
import { resolve, reject } from 'q';
import Qs from 'qs';

// const URL = 'http://soraadmin.wsandos.com/'; //地址  http://dayue.wsandos.com/
const URL = 'https://admin.sorabrand.com/';

// let user_token = sessionStorage.getItem || '';
axios.defaults.timeout = 15000;

/**
 *
 * @param  url 地址
 * @param  data 传参
 */
export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		let user_token = localStorage.getItem('token') || '';
		// let user_token = 'e195c8ba2db024f62ab17c6a6bd50bdc8ae1c2d9';
		data.token = user_token;
		axios({
			method: 'post',
			url: URL + url,
			transformRequest: [(data) => Qs.stringify(data)],
			// data: {
			//   data: JSON.stringify(data)
			// },
			data: data,
			withCredentials: false, // `withCredentials` 表示跨域请求时是否需要使用凭证
		}).then(
			(res) => {
				// console.log(res.data,'请求成功--------------');
				if (res.data.code == 200) {
					resolve(res.data);
				} else {
				}

				return false;
				// 判断返回状态
			},
			(err) => {
				reject(err);
			}
		);
	});
}

/**
 *
 * @param  url 地址
 * @param  params 传参
 */
export function get(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(URL + url, { params: params }).then(
			(res) => {
				resolve(res.data);
			},
			(err) => {
				reject(err);
			}
		);
	});
}
